module.exports = __webpack_public_path__ + "img/ewm.eff0d11a.png";